import type { ReactNode } from 'react';
import { DateInput } from '@/components/DateInput';

/**
 * Barra de período dos relatórios.
 *
 * Fica no mesmo lugar da FilterBar das listas: o operador procura o recorte de
 * data sempre no topo, seja numa lista ou num relatório.
 */
export function PeriodBar({
  from,
  to,
  onFrom,
  onTo,
  children,
}: {
  from: string;
  to: string;
  onFrom: (value: string) => void;
  onTo: (value: string) => void;
  children?: ReactNode;
}) {
  return (
    <div className="filterbar">
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5 }}>
        <span className="muted">De</span>
        <DateInput
          className="input"
          value={from}
          onChange={(iso) => onFrom(iso)}
          style={{ width: 150 }}
        />
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5 }}>
        <span className="muted">até</span>
        <DateInput
          className="input"
          value={to}
          onChange={(iso) => onTo(iso)}
          style={{ width: 150 }}
        />
      </label>
      {children}
    </div>
  );
}
